import { all, spawn } from 'redux-saga/effects';
import JobTitleSaga from 'redux/sagas/JobTitle/JobTitleSaga';
import AdminInfoSaga from 'redux/sagas/AdminInfo/AdminInfoSaga';
import DepartmentSaga from 'redux/sagas/Department/DepartmentSaga';
import HomeSaga from 'redux/sagas/Home/HomeSaga';
import GnbMenuSaga from 'redux/sagas/GnbMenu/GnbMenuSaga';
import BoardSaga from 'redux/sagas/Board/BoardSaga';
import AnniversarySaga from 'redux/sagas/Anniversary/AnniversarySaga';
import InvitationSaga from 'redux/sagas/Employee/InvitationSaga';
import EmployeeSaga from 'redux/sagas/Employee/EmployeeSaga';
import AccountSaga from 'redux/sagas/Employee/AccountSaga';
import InstantSaga from 'redux/sagas/Employee/InstantSaga';
import TermSaga from 'redux/sagas/Terms/TermSaga';

export default function* rootSaga() {
  try {
    yield all([
      spawn(JobTitleSaga),
      spawn(AdminInfoSaga),
      spawn(DepartmentSaga),
      spawn(GnbMenuSaga),
      spawn(BoardSaga),
      spawn(AnniversarySaga),
      spawn(HomeSaga),
      spawn(EmployeeSaga),
      spawn(InvitationSaga),
      spawn(InstantSaga),
      spawn(AccountSaga),
      spawn(TermSaga),
    ]);
  } catch (err) {
    console.log(err);
  }
}
